import { loadModal } from '../../AsyncLoader';
import DeleteModalMessageType from '../../cart/DeleteModalMessageType';
import FormSubmitButton from '../../forms/FormSubmitButton';
import dom from '../../utils/dom';
import ContentStorage, { ComponentKeys } from '../content/ContentStorage';

class DeleteItemConfirmationResult {
  constructor(
    public isConfirmed: boolean,
    public closeModal?: () => void,
  ) {
  }
}

function getModalProperties(messageType: string, modalTitle: string) {
  const cartKey = ComponentKeys.CART;

  const text = messageType === DeleteModalMessageType.InventoryItem
    ? ContentStorage.get(cartKey, 'Body')
    : ContentStorage.get(cartKey, 'RemoveNonInventoryItemSectionText');

  return {
    text,
    title: modalTitle,
    labelBtnConfirm: ContentStorage.get(cartKey, 'DeleteItemButtonText'),
    labelBtnCancel: ContentStorage.get(cartKey, 'CancelButtonText'),
  };
}

function getModalBody(text: string, $summary: Node | undefined): HTMLElement {
  const $el = dom.makeElement('div');
  $el.innerHTML = text;

  if ($summary) {
    const $summaryContainer = dom.makeElement('div', { class: 'tn-remove-item__summary' });
    $summaryContainer.appendChild($summary);
    $el.prepend($summaryContainer);
  }

  return $el;
}

async function getDeleteItemConfirmation({ messageType, modalTitle, $content }: {
  messageType: string,
  modalTitle: string,
  $content?: Node;
}): Promise<DeleteItemConfirmationResult> {
  const Modal = await loadModal();

  const {
    labelBtnCancel,
    labelBtnConfirm,
    text,
    title,
  } = getModalProperties(messageType, modalTitle);

  return new Promise((resolve) => {
    const contents = getModalBody(text, $content);
    const modal = Modal.confirm({
      title,
      labelBtnConfirm,
      labelBtnCancel,
      closeOnConfirm: false,
      bodyContents: contents,
      describedById: 'tn-delete-cart-item-alert-message',
      onConfirm: () => {
        FormSubmitButton.applyBusyStyling(modal.getButtonConfirm());
        resolve(new DeleteItemConfirmationResult(true, () => modal.close()));
      },
      beforeClose: () => {
        resolve(new DeleteItemConfirmationResult(false));
      },
    });
  });
}

export default getDeleteItemConfirmation;
